module.exports = __webpack_public_path__ + "img/P150T_weapon_157.663f6f58.png";